import socketService from "./socket.service";
import * as Bluebird from "bluebird";
export default {
    logout: function () {
        return Bluebird.try(function sendLogout() {
            return socketService.emit("session.logout", { logout: true });
        });
    }
};



//////////////////
// WEBPACK FOOTER
// ./js/services/session.helper.ts
// module id = V7BR
// module chunks = 1